var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticStyle:{"z-index":"300"},attrs:{"value":_vm.getLoading}},[_c('v-progress-circular',{staticClass:"custom-loader",attrs:{"indeterminate":"","size":"70","width":"5","color":"secondary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }